import css from 'styled-jsx/css';
import { SITE_KEY } from 'constants/site';

// these colors are more one-offs (for now)
const palette = {
  background: SITE_KEY === 'at' ? '#fcd1d4' : '#ffe097',
  color: SITE_KEY === 'at' ? '#f5656e' : '#ffbb18'
};

export default css`
  .BylineImagePlaceholder {
    padding: 0.5em;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${palette.color};
    background-color: ${palette.background};
  }
`;
